export const initializeSegment = (): any => {
    const analytics = (window.analytics = window.analytics || []);
    if (!analytics.initialize) {
        if (analytics.invoked) {
            window.console &&
                console.error &&
                console.error('Segment snippet included twice.');
        } else {
            analytics.invoked = !0;
            analytics.methods = [
                'trackSubmit',
                'trackClick',
                'trackLink',
                'trackForm',
                'pageview',
                'identify',
                'reset',
                'group',
                'track',
                'ready',
                'alias',
                'debug',
                'page',
                'once',
                'off',
                'on',
                'addSourceMiddleware',
                'addIntegrationMiddleware',
                'setAnonymousId',
                'addDestinationMiddleware'
            ];
            analytics.factory = function(e: any) {
                return function() {
                    // eslint-disable-next-line prefer-rest-params
                    const t = Array.prototype.slice.call(arguments);
                    t.unshift(e);
                    analytics.push(t);
                    return analytics;
                };
            };
            for (let e = 0; e < analytics.methods.length; e++) {
                const key = analytics.methods[e];
                analytics[key] = analytics.factory(key);
            }
            analytics.load = function(key: any, e: any) {
                const t = document.createElement('script');
                t.type = 'text/javascript';
                t.async = !0;
                t.src =
                    'https://cdn.segment.com/analytics.js/v1/' +
                    key +
                    '/analytics.min.js';
                const n = document.getElementsByTagName('script')[0];
                (n as any).parentNode.insertBefore(t, n);
                analytics._loadOptions = e;
            };
            analytics._writeKey = `${process.env.REACT_APP_SEGMENT_API_KEY}`;
            analytics.SNIPPET_VERSION = '4.15.3';
            analytics.load(`${process.env.REACT_APP_SEGMENT_API_KEY}`);
            analytics.page();
        }
    }
};
